import './StepCard.css';

function StepCard({ icon, title, description, className }) {
  return (
    <div className={`card_wrapper ${className}`}>
      <div className="step-icon">
        <img src={icon} alt={title} />
      </div>
      <div className="step-card">
        <h3>{title}</h3>
        <p>{description}</p>
      </div>
    </div>
  );
}

export default StepCard;
